export default function isUrlWhitelisted(url: string, whitelistedUrls: string[]) {
    const normalized = normalizeUrl(url);
    if (normalized === null) return false;

    for (var i = 0; i < whitelistedUrls.length; i++) {
        const rawPattern = whitelistedUrls[i];
        const pattern = stripQueryAndFragment(rawPattern);
        if (!pattern) continue;

        // A pattern that specifies a query/fragment matches any URL query/fragment, so drop
        // them from the URL for that comparison. Otherwise the URL's must match the pattern.
        const target = pattern === rawPattern ? normalized : stripQueryAndFragment(normalized);

        var regex = wildcardToRegExp(pattern);
        if (regex.test(target)) {
            return true;
        }
    }

    return false;
}

function stripQueryAndFragment(str: string): string {
    const index = str.search(/[?#]/);
    return index === -1 ? str : str.slice(0, index);
}

function normalizeUrl(url: string): string | null {
    // Reject control characters (e.g. \n, \t) that parsers silently strip, which could otherwise bypass whitelist checks.
    if (/[\x00-\x1f\x7f]/.test(url)) return null;

    let parsed: URL;
    try {
        parsed = new URL(url);
    } catch {
        return null;
    }

    // Find the path start in the original string (first '/' after '://').
    // Using the original prefix instead of parsed.origin avoids two pitfalls:
    //   1. URL adds a trailing '/' to bare hostnames, breaking exact-host patterns.
    //   2. URL normalises the host (e.g. strips credentials from @-bypasses),
    //      which would hide the attack from the regex that correctly rejects it.
    const schemeEnd = url.indexOf('://');
    if (schemeEnd === -1) return null;
    const pathStart = url.indexOf('/', schemeEnd + 3);
    if (pathStart === -1) return url; // no path – no traversal possible, return as-is

    // Reconstruct with the URL-normalised (traversal-resolved) pathname.
    return url.slice(0, pathStart) + parsed.pathname + parsed.search + parsed.hash;
}

function wildcardToRegExp(str: string) {
    const authorityEnd = getAuthorityEndIndex(str);
    const authorityPart = str.slice(0, authorityEnd);
    const pathPart = str.slice(authorityEnd);

    const authoritySegments = authorityPart.split(/\*+/);
    // A bare wildcard with no fixed text (e.g. lone '*') is a true catch-all and
    // may cross '/'. A wildcard anchored to real host text (e.g. '*.example.com')
    // must not cross '/' or an attacker can bypass the check via a path segment.
    const hostWildcard = authoritySegments.some(s => s.length > 0) ? '[^/]*' : '.*';

    const authorityPattern = authoritySegments.map(regExpEscape).join(hostWildcard);
    const pathPattern = pathPart.split(/\*+/).map(regExpEscape).join('.*');

    return new RegExp('^' + authorityPattern + pathPattern + '$', 'i');
}

function getAuthorityEndIndex(str: string): number {
    const schemeEnd = str.indexOf('://');
    const searchFrom = schemeEnd === -1 ? 0 : schemeEnd + 3;
    const pathStart = str.indexOf('/', searchFrom);
    return pathStart === -1 ? str.length : pathStart;
}

function regExpEscape(str: string) {
    return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
}
